import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectFromToParam } from "../store/wizardCreate/wizardCreateSlice";

export const useFormTo = () => {
  const { prefix, route } = useSelector(selectFromToParam);

  return useMemo(() => ({ prefix, route }), [{ prefix, route }]);
};
